import React from 'react'
import { Chart } from 'react-google-charts';


export default ({usageTypeChartData, selectedBucket, usageTypeSlices}) => (
    <div style={{marginTop:40}}>
        {selectedBucket && (<Chart
          chartType="PieChart"
          data={usageTypeChartData}
          options={{
                    title : 'Usage Types for ' + selectedBucket.bucket_name,
                    'sliceVisibilityThreshold': 0.0000000000000000000000000000000000000000000000000000000000009,
                    chartArea: { 
                        left: 40, 
                        top:60,
                        width: '80%', 
                        height: '80%'
                    },
                    legend: {
                        position: 'none',
                        alignment: 'center',
                        textStyle: {color: '#363d4d', fontSize: 15}                        
                    },
                    fontName : 'Muli',
                    fontSize : 15
                    ,
                    tooltip: {
                        textStyle: {color: '#000', fontSize: 14}
                    },
                    slices: usageTypeSlices
                    }}
          graph_id="CulomnChartUsageTypeCost"
          width="100%"
          height="420px"
          legend_toggle
        />)}
    </div>
)